import * as React from 'react';
import {Button, ButtonColor, ButtonSize, ButtonType} from "@atoms/LinksAndButtons/Button";

import './style.scss';

import {Icon} from '@atoms/Media/Icon';
import {FormattedMessage} from 'react-intl';

interface Props {
    onClick: () => void;
}

export const ApartmentFullScreenButton: React.FC<Props> = ({onClick}) => {
    return (
        <Button
            onClick={onClick}
            iconBtn 
            icon={<Icon name="fullscreen" />}
            className="apartment-fullscreen-button" 
            buttonColor={ButtonColor.LIGHT} 
            buttonSize={ButtonSize.DEFAULT} 
            buttonType={ButtonType.DEFAULT} 
        >
            <FormattedMessage id="jm.features.appartmentViewer.fullscreen" />
        </Button>
    )
};
